// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__uUTyU","border":"style_border__T6eKQ","mobile":"style_mobile__5CV6h","laptop":"style_laptop__teUXO","v3":"style_v3__2j1ZV","dark":"style_dark__igbSW"};